import { render, staticRenderFns } from "./DrawdownInput.vue?vue&type=template&id=70ac8e5e&scoped=true"
import script from "./DrawdownInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./DrawdownInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DrawdownInput.vue?vue&type=style&index=0&id=70ac8e5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac8e5e",
  null
  
)

export default component.exports